import React from 'react';
import Typography from '@mui/material/Typography';

/**
 * Safely render content, converting objects to strings if needed
 */
const safeRender = (content) => {
  if (content == null) return '';

  // Primitive types that React can render
  if (
    typeof content === 'string' ||
    typeof content === 'number' ||
    typeof content === 'boolean'
  ) {
    return content;
  }

  // React elements
  if (React.isValidElement(content)) {
    return content;
  }

  // Arrays
  if (Array.isArray(content)) {
    return content.map((item, index) => (
      <React.Fragment key={index}>{safeRender(item)}</React.Fragment>
    ));
  }

  // Objects - convert to string (this prevents the error)
  if (typeof content === 'object') {
    return JSON.stringify(content);
  }

  return String(content);
};

/**
 * Reusable component for displaying an icon with text in inline-flex layout
 */
export default function IconText({
  icon: Icon,
  children,
  variant = 'body2',
  color = 'text.secondary',
  sx = {},
  ...props
}) {
  return (
    <Typography
      variant={variant}
      component="div"
      sx={{
        verticalAlign: 'middle',
        display: 'inline-flex',
        alignItems: 'center',
        color: color,
        ...sx,
      }}
      {...props}
    >
      {Icon && <Icon fontSize="inherit" />}
      <div style={{ paddingLeft: '8px' }}>{safeRender(children)}</div>
    </Typography>
  );
}
